import Router from './../../router'
import store from './../../store' // 需要添加 vuex
import { Message,loading } from 'element-ui'
import helper from './helper'
import axios from 'axios'
import interfacePagination from './interfacePagination'
let qs = require('querystring')
let root = "/api"
// let root="/zs-exchange"
// 引用axios，设置头文件
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 加载数据提示设置
let loading_ = null
let loadingOption = {
  lock: true,
  text: '拼命加载中',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)',
}		
let resStatusCode = {
  500: ''
}
let _interfaceName = ''
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
	loading_ = loading.service({loadingOption});

  return config
}, function (error) {
  Message.error(error.message ? error.message : "请求错误,请刷新后重试！！！")
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       }).then(() => {
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  loading_.close()
  return new Promise((resolve, reject) => {
    if (response.data.code == 200) {
      interfacePagination('setPagination', store, response.data.data, response.config.headers['x-author'])
      resolve(response.data)
    } else if (response.data.status == 401) {
      store.commit('addDialogRouter',{dialog:'login'})
    } else {
	  Message.error(response.data.msg)
      resolve(response.data)
    }
  })
}, function (error) {
   loading_.close()
   Message.error(error.message ? error.message : "请求错误,请刷新后重试！！！")
  return Promise.reject(error)
})

function apiAxios (method, subData,params, interfaceName_) {
  let url = subData.url
  let istoken = subData.istoken
  let option_ = {
    method: method,
    // 拼接参数
    url: method === 'GET' || method === 'DELETE' ? helper.queryString(url, params) : url,
    // data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    data: method === 'POST' || method === 'PUT' ? params : null,
    baseURL:root,
    timeout: 30000,
    headers: {
      // interfaceName: interfaceName_
      // 'x-author': 'interfaceName ' + interfaceName_
    },
    withCredentials: false
  }
  option_.headers['Token'] = store.getters.getToken	
  return axios(option_)
}

function apiAxiosForm (method, subData, params,interfaceName_) {
    let url = subData.url
    let istoken = subData.istoken
    let baseURL = root
    var formData = new FormData()
  	var configs = {
  		headers:{'Content-Type':'multipart/form-data'}
  	}
    for(var key in params){//遍历json对象的每个key/value对,p为key
     formData.append(key,params[key])
    }
    url= method === 'GET' ? helper.queryString(url, params) : url
    return axios.post(baseURL+url,formData)
}
export default {
  get: function (subData , params, interfaceName) {
    return apiAxios('GET', subData, params, interfaceName)
  },
  post: function (subData, params, interfaceName) {
    return apiAxios('POST', subData, params, interfaceName)
  },
  postForm: function (subData, params, interfaceName) {
    return apiAxiosForm('POST', subData, params, interfaceName)
  },
}
